import React, { useState } from 'react';

const LazyImageLoader = ({ src, alt, className = '' }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <img
      src={src}
      alt={alt}
      onLoad={() => setLoaded(true)}
      className={className}
      style={{
        width: '100%',
        height: 'auto',
        transition: 'filter 0.5s ease-out, transform 0.5s ease-out',
        filter: loaded ? 'none' : 'blur(20px)',
        transform: loaded ? 'scale(1)' : 'scale(1)',
      }}
    />
  );
};

export default LazyImageLoader;
